import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { enqueueNotification, updateUserVisits } from 'stores';
import { travelAppAxios } from 'lib/travelApp';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const usePutVisits = () => {
  const dispatch = useDispatch();

  const handleError = (err) => {
    const errorParams = {
      file: 'travelApp.mutations.usePutVisits',
    };

    dispatch(enqueueNotification('notification.travelApp.putUserVisit.fail', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    dispatch(updateUserVisits(res.user, res.visitId));
    dispatch(enqueueNotification('notification.travelApp.putUserVisit.success', 'success'));
  };

  return useMutation(
    async ({ user, visitId }) => {
      if (!visitId || !user) {
        throw new Error('Invalid data');
      }
      const path = `visit/${visitId}`;

      await travelAppAxios.put(path, user);
      return { user, visitId };
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
